import Paper from './paper'

export default Paper
